import styled from "styled-components";
import {
  whiteBgOnClickAnim,
  scaleOnClickAnim,
  btnRotateAnim,
} from "../../animations";

export const TabBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;
export const OuterBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 18px;
  ${(p) => (p.active ? "color: #483b3b;" : "color: #db4646;")};
  transition: all 0.167s;
  max-width: 80px;
  height: 36px;
  font-size: 16px;
  p {
    text-transform: uppercase;
    position: absolute;
    pointer-events: none;
  }
`;
export const Tab = styled.div`
  border: solid 3px #db4646;
  border-radius: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: ${(p) => (p.active ? "tab" : null)};
  animation-duration: 0.167s;
  animation-fill-mode: forwards;
  opacity: 1;
  ${(p) => (p.active ? "background: #db4646;" : "background: transparent;")};
  transition: all 0.167s;
  max-width: 80px;
  height: 36px;
  font-size: 16px;
  @keyframes tab {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    29% {
      opacity: 1;
      animation-timing-function: cubic-bezier(0.17, 0.17, 0.2, 1);
    }
    100% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    }
  }
`;

export const Header = styled.div`
  font-size: 10px;
 grid-template-columns: 32% 34% 34%;
  display: grid;
  margin: 10px 0;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns:  30% 20% 44%;
  margin-bottom: 10px;
  line-height: 1.6;
  grid-column-gap: 3%;
  font-size: 12px;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
  cursor: ${(p) => (p.cur ? "pointer" : "auto")};
`;

export const Exit = styled.div`
  border-radius: 50%;
  border: solid 3px #db4646;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  animation: ${(p) =>
    p.close ? scaleOnClickAnim : p.aboveAnim ? btnRotateAnim : null};
  animation-duration: ${(p) => (p.close ? "0.333s" : "0.5s")};
  animation-fill-mode: forwards;
  pointer-events: ${(p) => (p.soundPlayed ? "none" : "auto")};
  :after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
    border: solid 3px #ffffff;
    border-radius: 38px;
    opacity: 0;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
    animation: ${(p) => (p.close ? whiteBgOnClickAnim : null)};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
  }

  g {
    stroke: #db4646;
  }
  width: 36px;
  height: 36px;
`;

export const Item = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  ${(props) =>
    props.win
      ? "text-shadow:  0 0 5px #ff7070; filter: brightness(150%);"
      : "text-shadow:  none; filter: none;"}
  &&.profit {
    text-align: right;
    padding-right: 4px;
    display: flex;
    justify-content:flex-end;
  }
  .winAmount {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    p{
      display: flex;
    }
  }
  &&.icon {
    display: flex;
    align-items: center;
  }
  svg {
    height: 11px;
    path {
      fill: #db4646;
    }
  }
`;
export const Title = styled.div`
  text-transform: uppercase;
`;
